export enum AccountRoles {
    Admin = "Admin",
    Editor = "Editor",
    Viewer = "Viewer",
}